export default __webpack_public_path__ + "media/zurb/img/home/youtube-icon-5c1bc543507d89f53f1525d87738320c.svg";